// extracted by mini-css-extract-plugin
export default {"button":"ColorSwitcher_button__EJpQI","label":"ColorSwitcher_label__Oyk1R"};